module.exports = __webpack_public_path__ + "img/langues.2ecf83c0.png";